import { render, staticRenderFns } from "./DeleteTodoItemType.vue?vue&type=template&id=142d4bb8"
import script from "./DeleteTodoItemType.vue?vue&type=script&lang=js"
export * from "./DeleteTodoItemType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports